export const HOME = {
  emergentLink: "emergent-link",
  navLogo: "nav-logo",
  navLinkAbout: "nav-link-about",
  navLinkServices: "nav-link-services",
  navLinkIndustries: "nav-link-industries",
  navLinkTeam: "nav-link-team",
  navLinkContact: "nav-link-contact",
  navCtaPost: "nav-cta-post-job",
  navCtaResume: "nav-cta-submit-resume",
  heroPrimaryCta: "hero-post-job-btn",
  heroSecondaryCta: "hero-submit-resume-btn",
  heroScrollHint: "hero-scroll-hint",
  servicesAccordion: "services-accordion",
  serviceItem: (slug) => `service-item-${slug}`,
  industryItem: (slug) => `industry-item-${slug}`,
  teamMember: (slug) => `team-member-${slug}`,
  clientForm: "client-job-form",
  clientFormCompany: "client-form-company",
  clientFormContactName: "client-form-contact-name",
  clientFormEmail: "client-form-email",
  clientFormPhone: "client-form-phone",
  clientFormJobTitle: "client-form-job-title",
  clientFormLocation: "client-form-location",
  clientFormDescription: "client-form-description",
  clientFormSubmit: "client-form-submit",
  candidateForm: "candidate-resume-form",
  candidateFormName: "candidate-form-name",
  candidateFormEmail: "candidate-form-email",
  candidateFormPhone: "candidate-form-phone",
  candidateFormRole: "candidate-form-role",
  candidateFormMessage: "candidate-form-message",
  candidateFormResume: "candidate-form-resume",
  candidateFormSubmit: "candidate-form-submit",
  contactForm: "contact-form",
  contactFormName: "contact-form-name",
  contactFormEmail: "contact-form-email",
  contactFormMessage: "contact-form-message",
  contactFormSubmit: "contact-form-submit",
  footerLinkTerms: "footer-link-terms",
  footerLinkPrivacy: "footer-link-privacy",
  footerLinkHome: "footer-link-home",
};
